// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-select-option-container {
  display: flex;
  flex-direction: row;
}

.color-select-option-text {
  font-size: var(--font-size-m);
}

.color-select-option-color {
  width: 50px;
  border-radius: 30px; /* 50% doesn't work as we want, 50px does (Need to be at least half the height, but as we don't know the height here, just use something big enough) */
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/color-select/color-select-option/ColorSelectOption.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,mBAAmB,EAAE,sJAAsJ;AAC7K","sourcesContent":[".color-select-option-container {\n  display: flex;\n  flex-direction: row;\n}\n\n.color-select-option-text {\n  font-size: var(--font-size-m);\n}\n\n.color-select-option-color {\n  width: 50px;\n  border-radius: 30px; /* 50% doesn't work as we want, 50px does (Need to be at least half the height, but as we don't know the height here, just use something big enough) */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
